__turbopack_context__.v({
  "activeOfferListItem": "_6HczXW_activeOfferListItem",
  "activeOffersContainer": "_6HczXW_activeOffersContainer",
  "seeMoreText": "_6HczXW_seeMoreText",
});
